import { Injectable } from '@angular/core';
import { ApiService, PagedSearch, PagedResult, UtilService } from '../../../shared/index';
import { ICardConnectService } from './icard-connect.service';
import { FundingResponse } from './funding-response.model';
import { Adjustment } from './adjustment.model';
import { Txn } from './txn.model';
import { Funding } from './funding.model';
import { TransDetail } from './trans-detail.model';

@Injectable()
export class CardConnectService implements ICardConnectService {
  public _apiService: ApiService;
  public _utilService: UtilService;
  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  public getFundingTransactions = (gatewayId: number, startDate: Date, endDate: Date): Promise<FundingResponse> => {
    var startDateAsString = this._utilService.getShortDateString(startDate);
    var endDateAsString = this._utilService.getShortDateString(endDate);
    var url =
      'CardConnect/FundingTransactions?gatewayId=' +
      gatewayId.toString() +
      '&startdate=' +
      startDateAsString +
      '&endDate=' +
      endDateAsString;
    return this._apiService.get(url).then((data: FundingResponse) => {
      for (var txn of data.txns) {
        if (txn.amount != undefined && txn.amount != null) {
          if (!isNaN(parseFloat(txn.amount))) {
            var parsedNum: number = parseFloat(txn.amount);
            txn.amountNumber = parsedNum;
          }
        }
      }
      return Promise.resolve(data);
    });
  };

  public getTransactionDetail = (gatewayId: number, retref: string): Promise<TransDetail> => {
    var url = 'CardConnect/TransactionDetails/' + gatewayId.toString() + '/' + retref;
    return this._apiService.get(url);
  };
}
